/**
 * Copyright (c) 2025 The xterm.js authors. All rights reserved.
 * @license MIT
 */

/**
 * The xterm.js version. This is updated by the publish script from package.json.
 */
export const XTERM_VERSION = '6.1.0-beta.220';
